import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
// Mui
import Typography from '@mui/material/Typography';
// Service
import Grid from '@mui/material/Grid';

import Button from '@mui/material/Button';
// import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
// import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
// import Box from '@mui/material/Box';
// import IconButton from '@mui/material/IconButton';
// import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { alpha } from '@mui/material/styles';
// import { MenuOrientation, ThemeMode } from 'types/config';
import useAuth from 'hooks/useAuth';

import { apiGetCurrentUser, updateKyc, updateKycAddress } from 'api/UserApi';
// import { Padding } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

// import { color } from 'framer-motion';
import { Formik } from 'formik';
import * as Yup from 'yup';
import MenuItem from '@mui/material/MenuItem';
// eslint-disable-next-line no-restricted-imports
import InputLabel from '@mui/material/InputLabel/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import moment from 'moment';
import KycPopupProgress from 'layout/MainLayout/Header/KycPopupProgress';
import SpinnerLoader from 'ui-component/Spinner';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { isBefore, subYears } from 'date-fns';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const KycSettings = styled(Grid)(({ theme }) => ({
    padding: '0px',
    // '.MuiOutlinedInput-input': { backgroundColor: 'none !important', Padding: '5px !important' },
    '.MuiGrid-item': { paddingTop: '0px !important' },
    '.uploadbtn': {
        marginTop: '8px',
        '.MuiButton-root': { top: '5px', height: '45px' }
    },
    '.datapicler': {
        svg: { color: '#fff' }
    },
    '.selectmenu': {
        svg: { color: '#fff' }
    },
    '.MuiTab-root.Mui-selected': { color: theme.palette.secondary.main },
    '.MuiTabs-indicator': { backgroundColor: theme.palette.secondary.main },
    '.MuiOutlinedInput-root': { backgroundColor: 'inherit' },
    '.MuiOutlinedInput-input': { color: '#fff' },
    '.MuiInputLabel-root': { color: '#fff !important' },
    '.uploadbutton': {}
}));

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
});

interface FormValues {
    firstName: string;
    middleName: string;
    lastName: string;
    dob: Date | string | null;
    outletId: string;
    kycDocumentType: string;
    kycDocumentID: string;
    documentFile: any[];
    status?: string | null;
    kycStatus?: string | null;
    image?: any[];
    selfieFile: string;
    selfieimage: string;
}

interface FormAddressValues {
    email: string;
    phone: string;
    address1: string;
    address2: string;
    countryCode: string;
    country: string;
    occupation: string;
    sourceOfIncome: string;
    nationality: string;
    income: string;
    postalCode: string;
    placeOfBirth: string;
}

const validationSchemaPersonal = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    kycDocumentType: Yup.string().required('Document Type is required'),
    kycDocumentID: Yup.string().required('Document ID is required'),
    outletId: Yup.string().required('Nearest Outlet is required'),
    dob: Yup.date()
        .required('Date of birth is required')
        .typeError('Invalid date format')
        .test(
            'is-past-date',
            'Date of birth cannot be in the future',
            (value) => !value || isBefore(value, new Date()) // Handles null/undefined and checks the date
        )
        .test(
            'is-valid-age',
            'You must be at least 21 years old',
            (value) => !value || isBefore(value, subYears(new Date(), 21)) // Handles null/undefined and checks the age
        )
});

const validationSchemaAddress = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
    phone: Yup.string().required('Phone is required'),
    occupation: Yup.string().required('Occupation is required'),
    sourceOfIncome: Yup.string().required('Source Of Income is required'),
    income: Yup.string().required('income is required'),
    nationality: Yup.string().required('Nationality is required'),
    placeOfBirth: Yup.string().required('place Of Birth is required'),
    address1: Yup.string().required('Address Line 1 is required'),
    address2: Yup.string().required('Address Line 2 is required'),
    postalCode: Yup.string().required('Postal Code is required'),
    country: Yup.string().required('Country is required')
});

const nationalityDropdownList = [
    'afghan',
    'albanian',
    'algerian',
    'american',
    'andorran',
    'angolan',
    'antiguans',
    'argentinean',
    'armenian',
    'australian',
    'austrian',
    'azerbaijani',
    'bahamian',
    'bahraini',
    'bangladeshi',
    'barbadian',
    'barbudans',
    'batswana',
    'belarusian',
    'belgian',
    'belizean',
    'beninese',
    'bhutanese',
    'bolivian',
    'bosnian',
    'brazilian',
    'british',
    'bruneian',
    'bulgarian',
    'burkinabe',
    'burmese',
    'burundian',
    'cambodian',
    'cameroonian',
    'canadian',
    'cape verdean',
    'central african',
    'chadian',
    'chilean',
    'chinese',
    'colombian',
    'comoran',
    'congolese',
    'costa rican',
    'croatian',
    'cuban',
    'cypriot',
    'czech',
    'danish',
    'djibouti',
    'dominican',
    'dutch',
    'east timorese',
    'ecuadorean',
    'egyptian',
    'emirian',
    'equatorial guinean',
    'eritrean',
    'estonian',
    'ethiopian',
    'fijian',
    'filipino',
    'finnish',
    'french',
    'gabonese',
    'gambian',
    'georgian',
    'german',
    'ghanaian',
    'greek',
    'grenadian',
    'guatemalan',
    'guinea-bissauan',
    'guinean',
    'guyanese',
    'haitian',
    'herzegovinian',
    'honduran',
    'hungarian',
    'icelander',
    'indian',
    'indonesian',
    'iranian',
    'iraqi',
    'irish',
    'israeli',
    'italian',
    'ivorian',
    'jamaican',
    'japanese',
    'jordanian',
    'kazakhstani',
    'kenyan',
    'kittian and nevisian',
    'kuwaiti',
    'kyrgyz',
    'laotian',
    'latvian',
    'lebanese',
    'liberian',
    'libyan',
    'liechtensteiner',
    'lithuanian',
    'luxembourger',
    'macedonian',
    'malagasy',
    'malawian',
    'malaysian',
    'maldivan',
    'malian',
    'maltese',
    'marshallese',
    'mauritanian',
    'mauritian',
    'mexican',
    'micronesian',
    'moldovan',
    'monacan',
    'mongolian',
    'moroccan',
    'mosotho',
    'motswana',
    'mozambican',
    'namibian',
    'nauruan',
    'nepalese',
    'new zealander',
    'ni-vanuatu',
    'nicaraguan',
    'nigerien',
    'north korean',
    'northern irish',
    'norwegian',
    'omani',
    'pakistani',
    'palauan',
    'panamanian',
    'papua new guinean',
    'paraguayan',
    'peruvian',
    'polish',
    'portuguese',
    'qatari',
    'romanian',
    'russian',
    'rwandan',
    'saint lucian',
    'salvadoran',
    'samoan',
    'san marinese',
    'sao tomean',
    'saudi',
    'scottish',
    'senegalese',
    'serbian',
    'seychellois',
    'sierra leonean',
    'singaporean',
    'slovakian',
    'slovenian',
    'solomon islander',
    'somali',
    'south african',
    'south korean',
    'spanish',
    'sri lankan',
    'sudanese',
    'surinamer',
    'swazi',
    'swedish',
    'swiss',
    'syrian',
    'taiwanese',
    'tajik',
    'tanzanian',
    'thai',
    'togolese',
    'tongan',
    'trinidadian or tobagonian',
    'tunisian',
    'turkish',
    'tuvaluan',
    'ugandan',
    'ukrainian',
    'uruguayan',
    'uzbekistani',
    'venezuelan',
    'vietnamese',
    'welsh',
    'yemenite',
    'zambian',
    'zimbabwean'
];

const KYC = ({ ...others }) => {
    const [tab, setTab] = useState(0);
    //const [user, setUser] = useState<User>();
    const theme = useTheme();
    const navigate = useNavigate();

    // const [valueBasic, setValueBasic] = React.useState<Date | null>(new Date());
    const [documentPreview, setDocumentPreview] = useState<string | null>(null);
    const [selfiePreview, setSelfiePreview] = useState<string | null>(null);
    const [imageuploadStatus, setImageuploadStatus] = useState(false);
    const [imageuploadSizeStatus, setImageuploadSizeStatus] = useState(false);
    const [selfieimageuploadStatus, setSelfieImageuploadStatus] = useState(false);
    const [selfieimageuploadSizeStatus, setSelfieImageuploadSizeStatus] = useState(false);
    const [serviceStatus, setServiceStatus] = useState(false);
    const { user } = useAuth();
    const [maxDate, setMaxDate] = useState('');
    const [maxValue, setMaxValue] = useState('');
    // console.log(user);
    const [initialValuesPersonal, setInitialValuesPersonal] = useState<FormValues>({
        firstName: '',
        middleName: '',
        lastName: '',
        dob: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
        kycDocumentType: '',
        outletId: '',
        image: [],
        kycDocumentID: '',
        status: '',
        kycStatus: '',
        documentFile: [],
        selfieFile: '',
        selfieimage: ''
    });

    const [initialValuesAddress, setInitialValuesAddress] = useState<FormAddressValues>({
        email: '',
        phone: '',
        address1: '',
        address2: '',
        countryCode: '',
        occupation: '',
        sourceOfIncome: '',
        income: '',
        nationality: '',
        postalCode: '',
        country: 'PH',
        placeOfBirth: ''
    });

    const handleTabChange = (_: any, newValue: number) => {
        setTab(newValue);
    };
    const fileSize = 1048576 * 2;
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setImageuploadStatus(false);
        setImageuploadSizeStatus(false);

        console.log(file, 'file.type-1');
        console.log(file?.type, 'file.type-2');

        if (file && file.size <= fileSize && file.type.startsWith('image/')) {
            //setImageuploadStatus(true);
            const reader = new FileReader();
            reader.onload = () => setDocumentPreview(reader.result as string);
            reader.readAsDataURL(file);
        } else {
            setImageuploadSizeStatus(true);
        }
    };
    const handleselfieFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setSelfieImageuploadStatus(false);
        setSelfieImageuploadSizeStatus(false);

        if (file && file.size <= fileSize && file.type.startsWith('image/')) {
            //setSelfieImageuploadStatus(true);
            const reader = new FileReader();
            reader.onload = () => setSelfiePreview(reader.result as string);
            reader.readAsDataURL(file);
        } else {
            setSelfieImageuploadSizeStatus(true);
        }
    };

    const handleSubmitAddress = async (values: FormAddressValues) => {
        const response = await updateKycAddress(values);
        console.log(response, 'response');
        if (response.userModel.userId) {
            setServiceStatus(true);
            toast('Thank you for submitting', {
                position: 'top-right',
                autoClose: 5000, // Close after 5 seconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        }
    };

    const handleSubmitPersonal = async (values: FormValues) => {
        console.log(values.documentFile);
        setSelfieImageuploadStatus(false);
        // setSelfieImageuploadSizeStatus(false);
        setImageuploadStatus(false);
        // setImageuploadSizeStatus(false);

        let val = 0;

        if (!(Array.isArray(values.image) && values.image[0]) && values.documentFile.length === 0) {
            setImageuploadStatus(true);
            setImageuploadSizeStatus(true);
            val = 1;
            //return;
        } else if (!(Array.isArray(values.image) && values.image[0]) && imageuploadSizeStatus) {
            setImageuploadSizeStatus(true);
            val = 1;
        }
        if (!(Array.isArray(values.selfieimage) && values.selfieimage[0]) && values.selfieFile.length === 0) {
            setSelfieImageuploadStatus(true);
            setSelfieImageuploadSizeStatus(true);
            val = 1;
            //return;
        } else if (!(Array.isArray(values.selfieimage) && values.selfieimage[0]) && selfieimageuploadStatus) {
            setSelfieImageuploadSizeStatus(true);
            val = 1;
        }
        if (val === 1) {
            return;
        }
        values.outletId = 'PJS-002';
        try {
            const response = await updateKyc(values);
            if (response.userModel.userId) {
                // setServiceStatus(true);
                toast('Thank you for submitting. KYC verification typically takes 24-48 hours. We will notify you once its complete', {
                    position: 'top-right',
                    autoClose: 5000, // Close after 5 seconds
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
                setTab(1);
            }
        } catch (err: any) {
            console.error(err);
        }

        // Handle form submission logic here
        // actions.setSubmitting(false); // Set submitting to false after submission
    };

    const getMaxDate = (val: any) => {
        const start = moment().add(-21, 'y');
        console.log(start);
        const maxDate1 = moment(start).format('YYYY/MM/DD');
        const maxDate2 = moment(val, 'YYYY-MM-DD').format('YYYY/MM/DD');
        setMaxDate(maxDate1);
        setMaxValue(maxDate2);
    };

    // const handleSkip = () => {
    //     navigate('/');
    //     window.location.reload(); // this will reload the page after navigation
    // };

    useEffect(() => {
        const getUsers = async () => {
            try {
                const response = await apiGetCurrentUser();

                let imageData = [];
                const kycData = response?.kycDocumentPath;

                if (kycData && kycData !== 'NULL') {
                    try {
                        imageData = JSON.parse(kycData);
                    } catch (err) {
                        console.error('Failed to parse kycDocumentPath:', err);
                    }
                }
                let selfieimageData = [];
                if (response?.selfieFilePath) {
                    selfieimageData = JSON.parse(response.selfieFilePath ?? '[]');
                }

                setInitialValuesPersonal({
                    firstName: response?.firstName ?? '',
                    middleName: response?.middleName ?? '',
                    lastName: response?.lastName ?? '',
                    dob: response?.dob ?? new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
                    kycDocumentType: response?.kycDocumentType ?? '',
                    kycDocumentID: response?.kycDocumentID ?? '',
                    documentFile: [],
                    selfieFile: response?.selfieFile ?? '',
                    status: response?.status ?? '',
                    kycStatus: response?.kycStatus,
                    image: imageData,
                    selfieimage: selfieimageData,
                    outletId: 'PJS-002' //response?.outletId ?? 'PJS-002'
                });

                setInitialValuesAddress({
                    email: response?.email ?? '',
                    phone: response?.phone ?? '',
                    address1: response?.address1 ?? '',
                    address2: response?.address2 ?? '',
                    postalCode: response?.postalCode ?? '',
                    countryCode: response?.countryCode ?? '',
                    country: response?.country ?? '',
                    occupation: response?.occupation ?? '',
                    nationality: response?.nationality ?? '',
                    income: response?.income ?? '',
                    sourceOfIncome: response?.sourceOfIncome ?? '',
                    placeOfBirth: response?.placeOfBirth ?? ''
                });
                getMaxDate(response?.dob);
            } catch (err) {
                console.error('Failed to fetch user data:', err);
            }
        };

        getUsers();
    }, []);

    // console.log(values);

    return (
        <KycSettings>
            <Grid container>
                <Grid item xs={12}>
                    <Typography
                        variant="h3"
                        sx={{ color: theme.palette.secondary.main, fontSize: '22px', fontWeight: '600', paddingTop: '20px' }}
                    >
                        <span>KYC Verification {user?.kycStatus ? `- ${user?.kycStatus.toUpperCase()}` : ''}</span>
                    </Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: '500', margin: '6px 0px 25px 0px' }}>
                        Please share the following details to verify your identity
                    </Typography>
                </Grid>
            </Grid>
            <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 3 }}>
                <Tab label="Personal Info" />
                <Tab label="Address Info" />
            </Tabs>
            {tab === 0 && (
                <Formik
                    enableReinitialize
                    initialValues={initialValuesPersonal}
                    validationSchema={validationSchemaPersonal}
                    onSubmit={handleSubmitPersonal}
                >
                    {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
                        <form noValidate onSubmit={handleSubmit} {...others}>
                            <>
                                <Grid
                                    container
                                    className=""
                                    sx={{
                                        background: '#050505',
                                        borderRadius: '10px',
                                        padding: '20px',
                                        border: '1px solid',
                                        borderColor: '#FFFFFF86'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: theme.palette.secondary.main,
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        Add Your Basic Details
                                    </Typography>
                                    <Grid container spacing={{ xs: 0, sm: 2 }} sx={{ padding: '0px' }}>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.firstName && errors.firstName)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="firstName"
                                                    name="firstName"
                                                    label="First Name"
                                                    value={values.firstName}
                                                    onChange={handleChange}
                                                    error={touched.firstName && Boolean(errors.firstName)}
                                                    helperText={touched.firstName && errors.firstName}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.middleName && errors.middleName)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="outlined-adornment-email-register"
                                                    type="text"
                                                    value={values.middleName}
                                                    label="Middle Name"
                                                    name="middleName"
                                                    // onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    inputProps={{}}
                                                    error={touched.middleName && Boolean(errors.middleName)}
                                                    helperText={touched.middleName && errors.middleName}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.lastName && errors.lastName)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="outlined-adornment-email-register"
                                                    type="text"
                                                    value={values.lastName}
                                                    label="Last Name"
                                                    name="lastName"
                                                    // onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    inputProps={{}}
                                                    error={touched.lastName && Boolean(errors.lastName)}
                                                    helperText={touched.lastName && errors.lastName}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                //className="datapicler"
                                                error={Boolean(touched.dob && errors.dob)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        format="dd/MM/yyyy"
                                                        value={values.dob ? new Date(values.dob) : null}
                                                        name="dob"
                                                        label="Dob"
                                                        //maxDate={maxDate}
                                                        onChange={(date) => setFieldValue('dob', date)}
                                                        // renderInput={(params) => <TextField {...params} fullWidth />}
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                error: Boolean(touched.dob && errors.dob), // Pass the error state
                                                                helperText: touched.dob && errors.dob // Pass the error message
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.outletId && errors.outletId)}
                                                sx={{ ...theme.typography.customInput }}
                                                className="selectmenu"
                                            >
                                                {/* <InputLabel id="demo-simple-select-label">Province / Cit</InputLabel> */}
                                                <InputLabel
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '0px !important'
                                                        // color: '#121926 !important'
                                                    }}
                                                    id="age-select"
                                                >
                                                    Nearest Outlet
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    onChange={handleChange}
                                                    value={values.outletId}
                                                    name="outletId"
                                                    label="outletId"
                                                >
                                                    <MenuItem value="PJS-001">Baesa, Quezon City - Baesa Towncenter</MenuItem>
                                                    <MenuItem value="PJS-002">Mayamot, Antipolo City - 23 Sumulong Highway</MenuItem>
                                                    <MenuItem value="PJS-003">Greenhills, San Juan City - Greenhills Promenade</MenuItem>
                                                    <MenuItem value="PJS-004">
                                                        Sta Rosa Laguna – Calypso Resort Hotel, Natl Highway
                                                    </MenuItem>
                                                    <MenuItem value="PJS-005">
                                                        Quezon Avenue, Quezon City - Sunshine Boulevard Plaza
                                                    </MenuItem>
                                                    <MenuItem value="PJS-006">
                                                        P Tuazon Avenue, Quezon City - Isetann Supermarket Bldg
                                                    </MenuItem>
                                                    <MenuItem value="PJS-007">
                                                        Morong, Rizal - Morong Centerpoint. Manila East Road
                                                    </MenuItem>
                                                    <MenuItem value="PJS-008">
                                                        Mandaue City, Cebu - Colonnade Supermarket, B. Cenniza
                                                    </MenuItem>
                                                    <MenuItem value="PJS-009">Sta Rosa Laguna - Estrella Commercial Center</MenuItem>
                                                    <MenuItem value="ETA-001">Del Carmen, Siargao - Numancia Mall</MenuItem>
                                                    <MenuItem value="ETA-002">Tropicana</MenuItem>
                                                </Select>
                                                {touched.outletId && errors.outletId && <FormHelperText>{errors.outletId}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    className=""
                                    sx={{
                                        background: '#050505',
                                        borderRadius: '10px',
                                        padding: '20px',
                                        border: '1px solid',
                                        borderColor: '#FFFFFF86',
                                        marginTop: '30px'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: theme.palette.secondary.main,
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        Upload Documents
                                    </Typography>
                                    <Grid container spacing={{ xs: 0, sm: 2 }} sx={{ padding: '0px' }}>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.kycDocumentType && errors.kycDocumentType)}
                                                sx={{ ...theme.typography.customInput }}
                                                className="selectmenu"
                                            >
                                                {/* <TextField fullWidth id="firstName" name="Document Type" label="DocumentType" /> */}
                                                <InputLabel
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '0px !important'
                                                        // color: '#121926 !important'
                                                    }}
                                                    id="document-select"
                                                >
                                                    Document Type
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    onChange={handleChange}
                                                    name="kycDocumentType"
                                                    value={values.kycDocumentType}
                                                    label="Document Type"
                                                >
                                                    <MenuItem value="driverlicense">Driver License</MenuItem>
                                                    <MenuItem value="umid">PhilHealth ID</MenuItem>
                                                    <MenuItem value="philhealthid">Driver License</MenuItem>
                                                    <MenuItem value="tin">Tax Identification(TIN)</MenuItem>
                                                    <MenuItem value="nationalid">Philippine National ID</MenuItem>
                                                    <MenuItem value="voterid">Voter Id</MenuItem>
                                                    <MenuItem value="passport">Passport</MenuItem>
                                                    <MenuItem value="sss">Social Security System Card</MenuItem>
                                                    <MenuItem value="postalid">Postal ID</MenuItem>
                                                </Select>
                                                {touched.kycDocumentType && errors.kycDocumentType && (
                                                    <FormHelperText>{errors.kycDocumentType}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                //error={Boolean(touched.lastName && errors.lastName)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="outlined-adornment-docid-register"
                                                    type="text"
                                                    value={values.kycDocumentID}
                                                    label="Document ID/Number"
                                                    name="kycDocumentID"
                                                    // onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    inputProps={{}}
                                                    error={touched.kycDocumentID && Boolean(errors.kycDocumentID)}
                                                    helperText={touched.kycDocumentID && errors.kycDocumentID}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl className="uploadbtn" fullWidth sx={{ ...theme.typography.customInput }}>
                                                <Button
                                                    className="232425"
                                                    sx={{
                                                        color: `${theme.palette.secondary.main} !important`,
                                                        background: 'none',
                                                        border: '2px dashed',
                                                        borderColor: theme.palette.secondary.main,
                                                        fontWeight: '800',
                                                        ':hover': {
                                                            background: 'none'
                                                        }
                                                    }}
                                                    component="label"
                                                    role={undefined}
                                                    variant="contained"
                                                    tabIndex={-1}
                                                >
                                                    Upload files
                                                    <VisuallyHiddenInput
                                                        type="file"
                                                        accept="image/jpeg, image/png"
                                                        onChange={(e) => {
                                                            setFieldValue('documentFile', e.target.files?.[0]);
                                                            handleFileChange(e);
                                                        }}
                                                    />
                                                </Button>

                                                <Typography
                                                    sx={{
                                                        color: '#f44336',
                                                        fontSize: '0.75rem',
                                                        fontWeight: '400',
                                                        lineHeight: '1.66',
                                                        textAlign: 'left',
                                                        margin: ' 8px 4px 0px'
                                                    }}
                                                >
                                                    {imageuploadStatus ? 'Document file is required' : ''}
                                                    {!imageuploadStatus && imageuploadSizeStatus
                                                        ? 'Please upload an image file smaller than 2 MB.'
                                                        : ''}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                        {/* Document Preview */}
                                        {documentPreview && (
                                            <Grid item xs={12} sm={2}>
                                                <img
                                                    src={documentPreview}
                                                    alt="Document Preview"
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '200px',
                                                        height: '45px',
                                                        marginTop: 14,
                                                        borderRadius: 8
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                        {Array.isArray(values.image) &&
                                            values.image[0] &&
                                            (!documentPreview || documentPreview.length === 0) && (
                                                <Grid item xs={12} sm={2}>
                                                    <img
                                                        src={values.image[0]}
                                                        alt="Document Preview"
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '200px',
                                                            height: '45px',
                                                            marginTop: 14,
                                                            borderRadius: 8
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    className=""
                                    sx={{
                                        background: '#050505',
                                        borderRadius: '10px',
                                        padding: '20px',
                                        border: '1px solid',
                                        borderColor: '#FFFFFF86',
                                        marginTop: '30px'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: theme.palette.secondary.main,
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        Upload Selfie with Document selected above
                                    </Typography>
                                    <Grid container spacing={{ xs: 0, sm: 2 }} sx={{ padding: '0px' }}>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl className="uploadbtn" fullWidth sx={{ ...theme.typography.customInput }}>
                                                <Button
                                                    className="uploadbutton"
                                                    sx={{
                                                        color: `${theme.palette.secondary.main} !important`,
                                                        background: 'none',
                                                        border: '2px dashed',
                                                        borderColor: theme.palette.secondary.main,
                                                        fontWeight: '800',
                                                        ':hover': {
                                                            background: 'none'
                                                        }
                                                    }}
                                                    component="label"
                                                    role={undefined}
                                                    variant="contained"
                                                    tabIndex={-1}
                                                >
                                                    Upload files
                                                    <VisuallyHiddenInput
                                                        type="file"
                                                        accept="image/jpeg, image/png"
                                                        onChange={(e) => {
                                                            setFieldValue('selfieFile', e.target.files?.[0]);
                                                            handleselfieFileChange(e);
                                                        }}
                                                    />
                                                </Button>

                                                <Typography
                                                    sx={{
                                                        color: '#f44336',
                                                        fontSize: '0.75rem',
                                                        fontWeight: '400',
                                                        lineHeight: '1.66',
                                                        textAlign: 'left',
                                                        margin: ' 8px 4px 0px'
                                                    }}
                                                >
                                                    {selfieimageuploadStatus ? 'Document file is required' : ''}
                                                    {!selfieimageuploadStatus && selfieimageuploadSizeStatus
                                                        ? 'Please upload an image file smaller than 2 MB.'
                                                        : ''}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                        {selfiePreview && (
                                            <Grid item xs={12} sm={2}>
                                                <img
                                                    src={selfiePreview}
                                                    alt="Document Preview"
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '200px',
                                                        height: '45px',
                                                        marginTop: 13,
                                                        borderRadius: 8
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                        {Array.isArray(values.image) &&
                                            values.image[0] &&
                                            (!selfiePreview || selfiePreview.length === 0) && (
                                                <Grid item xs={12} sm={2}>
                                                    <img
                                                        src={values.selfieimage[0]}
                                                        alt="Document Preview"
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '200px',
                                                            height: '45px',
                                                            marginTop: 13,
                                                            borderRadius: 8
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                    </Grid>
                                </Grid>

                                <Grid
                                    container
                                    className=""
                                    sx={{
                                        background: '#050505',
                                        borderRadius: '10px',
                                        padding: '20px',
                                        border: '1px solid',
                                        borderColor: '#FFFFFF86',
                                        marginTop: '30px'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: '#FFFF00',
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        If you're ready to deactivate your account, please follow this link:
                                        <a href="https://osea.pagcor.ph" target="_blank" rel="noreferrer">
                                            {' '}
                                            osea.pagcor.ph
                                        </a>
                                    </Typography>
                                </Grid>
                            </>

                            {(values.kycStatus === '' || values.kycStatus === null || values.kycStatus === 'decline') && (
                                <Grid container className="" sx={{ borderRadius: '10px', marginTop: '30px', justifyContent: 'flex-end' }}>
                                    <Button
                                        sx={{
                                            backgroundColor: alpha(theme.palette.secondary.main, 1),
                                            color: theme.palette.grey[500],
                                            fontWeight: '600',
                                            fontSize: '16px',
                                            paddingLeft: '40px',
                                            paddingRight: '40px',
                                            ':hover': {
                                                backgroundColor: alpha(theme.palette.secondary.main, 1),
                                                color: theme.palette.grey[500]
                                            }
                                        }}
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        {tab === 0 ? 'Next' : 'Save'} {isSubmitting && <SpinnerLoader />}
                                    </Button>
                                </Grid>
                            )}
                        </form>
                    )}
                </Formik>
            )}
            {tab === 1 && (
                <Formik
                    enableReinitialize
                    initialValues={initialValuesAddress}
                    validationSchema={validationSchemaAddress}
                    onSubmit={handleSubmitAddress}
                >
                    {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
                        <form noValidate onSubmit={handleSubmit} {...others}>
                            <>
                                <Grid
                                    container
                                    className=""
                                    sx={{
                                        background: '#050505',
                                        borderRadius: '10px',
                                        padding: '20px',
                                        border: '1px solid',
                                        borderColor: '#FFFFFF86'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: theme.palette.secondary.main,
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        Add your Personal Details
                                    </Typography>
                                    <Grid container spacing={{ xs: 0, sm: 2 }} sx={{ padding: '0px' }}>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl fullWidth sx={{ ...theme.typography.customInput }}>
                                                <TextField
                                                    fullWidth
                                                    id="outlined-adornment-email-register"
                                                    type="text"
                                                    value={values.email}
                                                    label="Email Address"
                                                    name="email"
                                                    // onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    inputProps={{}}
                                                    error={touched.email && Boolean(errors.email)}
                                                    helperText={touched.email && errors.email}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.phone && errors.phone)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <TextField
                                                    id="outlined-adornment-email-register"
                                                    type="text"
                                                    value={values.phone}
                                                    name="phone"
                                                    label="Mobile"
                                                    // onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    inputProps={{}}
                                                    error={touched.phone && Boolean(errors.phone)}
                                                    helperText={touched.phone && errors.phone}
                                                    disabled
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.occupation && errors.occupation)}
                                                sx={{ ...theme.typography.customInput }}
                                                className="selectmenu"
                                            >
                                                {/* <InputLabel id="demo-simple-select-label">Province / Cit</InputLabel> */}
                                                <InputLabel
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '0px !important'
                                                        // color: '#121926 !important'
                                                    }}
                                                    id="age-select"
                                                >
                                                    Occupation
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    onChange={handleChange}
                                                    value={values.occupation}
                                                    name="occupation"
                                                    label="Occupation"
                                                >
                                                    <MenuItem value="employee">Employee</MenuItem>
                                                    <MenuItem value="self-employed">Self-employed</MenuItem>
                                                    <MenuItem value="others">Others</MenuItem>
                                                </Select>
                                                {touched.occupation && errors.occupation && (
                                                    <FormHelperText>{errors.occupation}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.sourceOfIncome && errors.sourceOfIncome)}
                                                sx={{ ...theme.typography.customInput }}
                                                className="selectmenu"
                                            >
                                                {/* <InputLabel id="demo-simple-select-label">Province / Cit</InputLabel> */}
                                                <InputLabel
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '0px !important'
                                                        // color: '#121926 !important'
                                                    }}
                                                    id="age-select"
                                                >
                                                    Source of income
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    onChange={handleChange}
                                                    value={values.sourceOfIncome}
                                                    name="sourceOfIncome"
                                                    label="sourceOfIncome"
                                                >
                                                    <MenuItem value="salary">Salary</MenuItem>
                                                    <MenuItem value="business">Business</MenuItem>
                                                    <MenuItem value="pension">Pension</MenuItem>
                                                    <MenuItem value="others">Others</MenuItem>
                                                </Select>
                                                {touched.sourceOfIncome && errors.sourceOfIncome && (
                                                    <FormHelperText>{errors.sourceOfIncome}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.income && errors.income)}
                                                sx={{ ...theme.typography.customInput }}
                                                className="selectmenu"
                                            >
                                                {/* <InputLabel id="demo-simple-select-label">Province / Cit</InputLabel> */}
                                                <InputLabel
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '0px !important'
                                                        // color: '#121926 !important'
                                                    }}
                                                    id="age-select"
                                                >
                                                    Income
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    onChange={handleChange}
                                                    value={values.income}
                                                    name="income"
                                                    label="Income"
                                                >
                                                    <MenuItem value="Less_than_11000">Less than 11,000 ₱</MenuItem>
                                                    <MenuItem value="11000_21000">11,000 ₱ - 21,000 ₱</MenuItem>
                                                    <MenuItem value="21000_44000">21,000 ₱ - 44,000 ₱</MenuItem>
                                                    <MenuItem value="44000_76000">44,000 ₱ - 76,000 ₱</MenuItem>
                                                    <MenuItem value="76000_132000">76,000 ₱ - 132,000 ₱</MenuItem>
                                                    <MenuItem value="132000_220000">132,000 ₱ - 220,000 ₱</MenuItem>
                                                    <MenuItem value="above_220000">above 220,000 ₱</MenuItem>
                                                </Select>
                                                {touched.income && errors.income && <FormHelperText>{errors.income}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.nationality && errors.nationality)}
                                                sx={{ ...theme.typography.customInput }}
                                                className="selectmenu"
                                            >
                                                {/* <InputLabel id="demo-simple-select-label">Province / Cit</InputLabel> */}
                                                <InputLabel
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '0px !important'
                                                        // color: '#121926 !important'
                                                    }}
                                                    id="age-select"
                                                >
                                                    Nationality
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    onChange={handleChange}
                                                    value={values.nationality}
                                                    name="nationality"
                                                    label="nationality"
                                                    sx={{ textTransform: 'capitalize' }}
                                                >
                                                    {nationalityDropdownList.map((item: any, index: number) => (
                                                        <MenuItem key={index} value={item} sx={{ textTransform: 'capitalize' }}>
                                                            {item}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {touched.nationality && errors.nationality && (
                                                    <FormHelperText>{errors.nationality}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.placeOfBirth && errors.placeOfBirth)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="outlined-adornment-email-register"
                                                    type="text"
                                                    value={values.placeOfBirth}
                                                    label="Place Of Birth"
                                                    name="placeOfBirth"
                                                    // onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    inputProps={{}}
                                                    error={touched.placeOfBirth && Boolean(errors.placeOfBirth)}
                                                    helperText={touched.placeOfBirth && errors.placeOfBirth}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    className=""
                                    sx={{
                                        background: '#050505',
                                        borderRadius: '10px',
                                        padding: '20px',
                                        border: '1px solid',
                                        borderColor: '#FFFFFF86',
                                        marginTop: '30px'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: theme.palette.secondary.main,
                                            fontWeight: '500',
                                            fontSize: '16px',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        Add your address
                                    </Typography>
                                    <Grid container spacing={{ xs: 0, sm: 2 }} sx={{ padding: '0px' }}>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                //error={Boolean(touched.firstName && errors.firstName)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="outlined-adornment-address-1"
                                                    label="Current Address"
                                                    value={values.address1}
                                                    onChange={handleChange}
                                                    name="address1"
                                                    error={touched.address1 && Boolean(errors.address1)}
                                                    helperText={touched.address1 && errors.address1}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                //error={Boolean(touched.lastName && errors.lastName)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="outlined-adornment-address-2"
                                                    type="text"
                                                    value={values.address2}
                                                    label="Permanent Address"
                                                    name="address2"
                                                    error={Boolean(touched.address2 && errors.address2)}
                                                    // onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    inputProps={{}}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                //error={Boolean(touched.lastName && errors.lastName)}
                                                sx={{ ...theme.typography.customInput }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="outlined-adornment-email-register"
                                                    type="text"
                                                    value={values.postalCode}
                                                    label="Postal Code"
                                                    name="postalCode"
                                                    // onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    inputProps={{}}
                                                    error={touched.postalCode && Boolean(errors.postalCode)}
                                                    helperText={touched.postalCode && errors.postalCode}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl
                                                fullWidth
                                                error={Boolean(touched.country && errors.country)}
                                                sx={{ ...theme.typography.customInput }}
                                                className="selectmenu"
                                            >
                                                {/* <InputLabel id="demo-simple-select-label">Province / Cit</InputLabel> */}
                                                <InputLabel
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '0px !important'
                                                        // color: '#121926 !important'
                                                    }}
                                                    id="age-select"
                                                >
                                                    Country
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    onChange={handleChange}
                                                    value={values.country}
                                                    name="country"
                                                    label="country"
                                                >
                                                    <MenuItem value="PH">PH</MenuItem>
                                                </Select>
                                                {touched.country && errors.country && <FormHelperText>{errors.country}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>

                            {/* {(values.kycStatus === '' || values.kycStatus === null || values.kycStatus === 'decline') && ( */}
                            <Grid
                                container
                                className=""
                                sx={{ borderRadius: '10px', marginTop: '30px', justifyContent: 'flex-end', gap: '16px' }}
                            >
                                {/* <Button
                                    sx={{
                                        backgroundColor: '#e0e0e0',
                                        color: '#333',
                                        fontWeight: '600',
                                        fontSize: '16px',
                                        paddingLeft: '30px',
                                        paddingRight: '30px',
                                        ':hover': {
                                            backgroundColor: '#d5d5d5'
                                        }
                                    }}
                                    onClick={handleSkip} // define this function as needed
                                >
                                    Skip for Now1
                                </Button> */}

                                <Button
                                    sx={{
                                        backgroundColor: alpha(theme.palette.secondary.main, 1),
                                        color: theme.palette.grey[500],
                                        fontWeight: '600',
                                        fontSize: '16px',
                                        paddingLeft: '40px',
                                        paddingRight: '40px',
                                        ':hover': {
                                            backgroundColor: alpha(theme.palette.secondary.main, 1),
                                            color: theme.palette.grey[500]
                                        }
                                    }}
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    Save {isSubmitting && <SpinnerLoader />}
                                </Button>
                            </Grid>
                        </form>
                    )}
                </Formik>
            )}
            {serviceStatus && <KycPopupProgress />}
        </KycSettings>
    );
};

export default KYC;
